import { h, Component } from 'preact'

import { connect } from 'app/store'
import { api } from 'app/util/api'

import Input from 'app/components/Input'
import Form from 'app/components/Form'
import Button from 'app/components/Button'
import linkState from 'linkstate'
import Alert from 'react-s-alert'
import { route } from 'preact-router'

class ResetPassword extends Component {
  state = { password: null, password2: null }

  submit = async () => {
    const { password, password2 } = this.state
    const { tk: token } = this.props

    if (password !== password2) {
      return Alert.error('Passwords are different')
    }

    await api.post('/auth/password', { password, token })

    route('/login')
  }

  render() {
    const { password, password2 } = this.state

    return (
      <div>
        <h3 class="mb-5">Reset</h3>
        <Form onSubmit={() => this.submit()}>
          <Input
            label="Password"
            type="password"
            value={password}
            class="mb-3 w-100"
            onInput={linkState(this, 'password')}
            required
          />
          <Input
            label="Confirm password"
            type="password"
            value={password2}
            class="mb-3 w-100"
            onInput={linkState(this, 'password2')}
            required
          />
          <Button type="submit" class="float-right">
            Reset password
          </Button>
        </Form>
      </div>
    )
  }
}

export default connect(
  null,
  ResetPassword,
)



// WEBPACK FOOTER //
// ./pages/ResetPassword.js